import { defineMessages } from "react-intl";

export const navLabels = defineMessages({
  dashboard: {
    id: "C3vkZS",
    defaultMessage: "Dashboard",
    description: "Dashboard nav item",
  },
  posture: {
    id: "bqt9Wb",
    defaultMessage: "Posture",
    description: "Posture group nav item",
  },
  lifecycle: {
    id: "f5ma37",
    defaultMessage: "Lifecycle",
    description: "Lifecycle group nav item",
  },
  agents: {
    id: "KCGP41",
    defaultMessage: "Agents",
    description: "Agents nav item under Lifecycle",
  },
  "access-gateway": {
    id: "tUR/7R",
    defaultMessage: "Access Gateway",
    description: "Access Gateway nav item",
  },
  "agent-runtime-authz": {
    id: "jSQc4F",
    defaultMessage: "Runtime Authorization",
    description: "Agent Runtime Authz nav item",
  },
  identities: {
    id: "fCWhGr",
    defaultMessage: "Identities",
    description: "Identities nav item",
  },
  integrations: {
    id: "/KTPUS",
    defaultMessage: "Integrations",
    description: "Integrations nav item",
  },
  policies: {
    id: "Wp7keM",
    defaultMessage: "Posture Policies",
    description: "Posture Policies nav item",
  },
  agent: {
    id: "d3Duyd",
    defaultMessage: "Agent",
    description: "Agent nav item",
  },
  admin: {
    id: "VkJHPL",
    defaultMessage: "Admin",
    description: "Admin nav item",
  },
  "ispm-users": {
    id: "gR6dho",
    defaultMessage: "ISPM Users",
    description: "ISPM Users sub-nav item",
  },
  settings: {
    id: "031hPF",
    defaultMessage: "Settings",
    description: "Settings sub-nav item",
  },
  "sso-settings": {
    id: "CGGOy8",
    defaultMessage: "SSO Settings",
    description: "SSO Settings sub-nav item under Settings",
  },
});
